var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshCcw010(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 6.66667C1.33203 6.66667 2.66869 4.84548 3.75459 3.75883C4.84049 2.67218 6.3411 2 7.9987 2C11.3124 2 13.9987 4.68629 13.9987 8C13.9987 11.3137 11.3124 14 7.9987 14C5.2633 14 2.95544 12.1695 2.23321 9.66667M1.33203 6.66667V2.66667M1.33203 6.66667H5.33203",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCcw010);
export default __webpack_public_path__ + "static/media/refresh-ccw-010.6f8c3b12afefdb2ab1ee024b2d5a9a6e.svg";
export { ForwardRef as ReactComponent };